import { MergedFlight, Project } from "@nova/protobuf"
import {
    booleanValidator,
    createLayerValidator,
    nameValidators,
    UnionToTuple,
    updateLayerValidator,
} from "../util"
import { dateAsNumber } from "../../util"
import { createNewLayerFractionalIndex } from "../../util/fractional_indexing"

export const createMergedFlightValidator = createLayerValidator(MergedFlight, {
    name: { validators: nameValidators, nonNull: true },
    index: { validators: [], nonNull: true },
    parentId: { validators: [] },
})

export const updateMergedFlightValidator = updateLayerValidator(MergedFlight, {
    isSensitivitySynced: { validators: booleanValidator("isSensitivitySynced") },
})

export const getDefaultMergedFlightArgs = (project: Project, inParentId?: string) => {
    const parentId = !inParentId || inParentId === "null" ? undefined : inParentId
    return {
        visible: true,
        createdAt: dateAsNumber(),
        index: createNewLayerFractionalIndex(project, 0, parentId),
        parentId,
    }
}

export type CreateMergedFlightArgs = UnionToTuple<keyof typeof createMergedFlightValidator>
export type UpdateMergedFlightArgs = UnionToTuple<keyof typeof updateMergedFlightValidator>
